import {
  a as r,
  b as e,
  c as o
} from "./chunk-BVHSVHOK.js";

// src/browser.ts
var f = o(!1);
export {
  o as createColors,
  f as default,
  r as getDefaultColors,
  e as isSupported
};
